import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { useLocation, useNavigate } from "react-router-dom";
const Container = tw.div`relative bg-gray-300 text-gray-900 m-0 px-4`;

const Content = tw.div`max-w-screen-xl mx-auto pt-8 pb-8`;

const FiveColumns = tw.div`flex flex-wrap justify-between`;

const CompanyColumn = tw.div`text-left mb-8 lg:mb-0 w-full lg:w-1/5 md:w-1/4 sm:w-1/4`;

const LinksColumn1 = tw.div`text-left mb-8 md:ml-5 lg:mb-0 w-full md:w-1/6 sm:w-1/4`;

const CopyrightColumn = tw.div`w-full xs:w-3/4 sm:w-3/4 md:w-3/4 lg:w-1/4 mb-8 md:mb-0 text-sm sm:text-base`;
const CopyrightColumnpdf = tw.div`w-full xs:w-3/4 sm:w-3/4 md:w-3/4 lg:w-1/3 mb-8 md:mb-0 text-sm sm:text-base`;

const ColumnHeading = tw.h5`font-bold uppercase`;

const LinkList = tw.ul`mt-4 text-sm font-medium`;

const LinkListItem = tw.li`mt-3 cursor-pointer`;

const Link = tw.a`border-b-2 border-transparent hocus:text-teal-900 hocus:border-teal-900 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex lg:justify-start`;

const LogoText = tw.h5`ml-0 text-4xl text-indigo-600 font-bold hover:cursor-pointer`;

const CompanyAddress = tw.p`mt-4 max-w-xs font-medium text-sm lg:mx-0 lg:mr-4 leading-loose text-left`;

const CopyrightAndCompanyInfoRow = tw.div`pb-0 text-sm font-normal flex flex-col sm:flex-row justify-between items-start`;

const TrademarkDiscInfoRow = styled.div`
  ${tw`pb-0 text-xs pt-4 font-normal sm:flex-row justify-between items-start text-justify`}
  .trademark {
    ${tw`font-bold inline`}
  }
`;

const CopyrightNotice = tw.div``;

const FooterData = (
  <ColumnHeading>
    <CopyrightAndCompanyInfoRow>
      <CopyrightNotice>
        Copyright &copy; 2022-24 by Iqura Technologies PTE. LTD. All rights
        reserved.{" "}
      </CopyrightNotice>
    </CopyrightAndCompanyInfoRow>
    <TrademarkDiscInfoRow>
      <span className="trademark">Trademark Disclaimer:</span> All trademarks,
      logos and brand names are the property of their respective owners. All
      company, product and service names used in this website are for
      identification purposes only. Use of these names, trademarks and brands
      does not imply endorsement.
    </TrademarkDiscInfoRow>
  </ColumnHeading>
);

const Footer = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToWhoWeAre = () => {
    if (location.pathname === "/") {
      document.getElementById("whoweare").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("whoweare").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollToWhatWeDo = () => {
    if (location.pathname === "/") {
      document.getElementById("whatwedo").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("whatwedo").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollToTechstack = () => {
    if (location.pathname === "/") {
      document.getElementById("techstack").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("techstack").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollToCareer = () => {
    if (location.pathname === "/") {
      document.getElementById("career").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("career").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollToContactUs = () => {
    if (location.pathname === "/") {
      document.getElementById("contact").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("contact").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollTop = () => {
    if (location.pathname === "/") {
      document.getElementById("navbar").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("navbar").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  const scrollToOurServices = () => {
    if (location.pathname === "/") {
      document.getElementById("ourservices").scrollIntoView({
        behaviour: "smooth",
      });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("ourservices").scrollIntoView({
          behaviour: "smooth",
        });
      }, "300");
    }
  };

  return (
    <Container>
      <Content>
        <FiveColumns>
          <CompanyColumn>
            <LogoContainer>
              <LogoText className="logoFontFamily" onClick={() => scrollTop()}>
                Iqura
              </LogoText>
            </LogoContainer>
            <CompanyAddress>Iqura Technologies Pte. Ltd.</CompanyAddress>
            <CompanyAddress>
              143 Cecil Street #25-03 GB Building Singapore (069542)
            </CompanyAddress>
            <CompanyAddress>UEN: 201916856W</CompanyAddress>
          </CompanyColumn>
          {props.footer !== "pdf" && (
            <>
              <LinksColumn1>
                <ColumnHeading>Solutions</ColumnHeading>
                <LinkList>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/what-we-do/real-estate-software-company")
                      }
                    >
                      Real Estate Software
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() => navigate("/what-we-do/cloud-services")}
                    >
                      Cloud Services
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate(
                          "/what-we-do/customer-identity-and-access-management"
                        )
                      }
                    >
                      Identity & Access Mgmt (CIAM)
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/what-we-do/digital-transformation-services")
                      }
                    >
                      Digital Transformation
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/what-we-do/application-framework")
                      }
                    >
                    Application-in-a-box
                    </Link>
                  </LinkListItem>
                </LinkList>
              </LinksColumn1>

              <LinksColumn1>
                <ColumnHeading>Services</ColumnHeading>
                <LinkList>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/our-services/application-development")
                      }
                    >
                      Application Development
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() => navigate("/our-services/api-development")}
                    >
                      API Development
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/our-services/application-support")
                      }
                    >
                      Application Maintenance
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/our-services/third-party-api-integrations")
                      }
                    >
                      API Integrations
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/our-services/dedicated-development-teams")
                      }
                    >
                      Dedicated Teams
                    </Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link
                      onClick={() =>
                        navigate("/our-services/product-engineering")
                      }
                    >
                      Product Engineering
                    </Link>
                  </LinkListItem>
                </LinkList>
              </LinksColumn1>

              <LinksColumn1>
                <ColumnHeading>Company</ColumnHeading>
                <LinkList>
                  <LinkListItem>
                    <Link href="/">Home</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToWhatWeDo()}>What we do</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToOurServices()}>Our Services</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToTechstack()}>Techstack</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToWhoWeAre()}>Who we are</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToCareer()}>Careers</Link>
                  </LinkListItem>
                  <LinkListItem>
                    <Link onClick={() => scrollToContactUs()}>Contact</Link>
                  </LinkListItem>
                </LinkList>
              </LinksColumn1>
            </>
          )}
          {props.footer !== "pdf" ? (
            <CopyrightColumn>{FooterData}</CopyrightColumn>
          ) : (
            <CopyrightColumnpdf>{FooterData}</CopyrightColumnpdf>
          )}
        </FiveColumns>
      </Content>
    </Container>
  );
};

export default Footer;
